// -----------------------------------------------------------------------------
// Scripts for parralax effect
// -----------------------------------------------------------------------------

$(document).ready(function () {


  $(window).on('scroll', function () {
    $('.our-offer__bg-inner').addClass('parallax');
    var parallaxElements = $('.parallax'),
      parallaxQuantity = parallaxElements.length;
    window.requestAnimationFrame(function () {
      if (window.innerWidth > 1200) {
        for (var i = 0; i < parallaxQuantity; i++) {
          var currentElement = parallaxElements.eq(i);
          var scrolled = $(window).scrollTop();
          currentElement.css({
            'transform': 'translate3d(0,' + scrolled * -0.3 + 'px, 0)'
          });
        }
      } else {
        $('.our-offer__bg-inner').removeClass('parallax').css("transform", "none");
      }
    });
  });

});